import '../stylesheets/account.css';

import i18n from 'i18next'; // Import i18n instance
import React from 'react';
import {
  Alert,
  Button,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Tab,
  Tabs,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import {
  getMyAccountData,
  getMyBankAccountData,
  updateAccountData,
  updateBankAccountData,
} from '../actions/account';
import { logoutRequest } from '../actions/auth';
import { getMyContactTypes, updateContactTypes } from '../actions/contacts';
import {
  getMyMooringTypes,
  getMyMooringZones,
  updateMooringTypes,
  updateMooringZones,
} from '../actions/moorings';
import {
  deletePaymentMethod,
  getMyPaymentMethods,
  getPayrexxTokenizationLink,
} from '../actions/paymntMethods';
import DropDownIcon from '../assets/icons/dropdown.png';
import creditcard_active from '../assets/maintain_bookings_screen/creditcard_active.png';
import AddNewButton from '../components/AddNewButton';
import CountrySelector from '../components/CountrySelector';
import FormInput from '../components/FormInput';
import FormSegmentedControl from '../components/FormSegmentedControl';
import StatusAlerts from '../components/StatusAlerts';
import COLORS from '../constants/colors';
import { COMMUNICATION_LANGUAGES, CURRENCIES } from '../constants/constants';
import globalStyles from '../stylesheets/globalStyles';
import { validateAccountForm } from '../utils/validators';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      error: false,
      role: '',
      communication_language: '',
      firstname: '',
      lastname: '',
      email: '',
      mobilenumber: '',
      password: '',
      showPassword: false,
      passwordRepeat: '',
      showPasswordRepeat: false,
      referral_account: '',
      AcceptedTCs: false,
      confirm_bookings: false,
      confirmation_emails_own: false,
      bankAccountData: [],
      mooring_types: [],
      mooring_zones: [],
      contact_types: [],
      showMooringZones: false,
      showMooringTypes: false,
      showContactTypes: false,
      active_tab: 'account',
      payment_methods: [],
      payment_methods_loading: false,
      should_refresh_payment_methods_on_focus: false,
      new_payment_method_currency: '',
      payment_method_status: '',
    };
  }

  componentDidMount() {
    window.addEventListener('focus', this.handleWindowFocus);
    getMyAccountData(this.getMyAccountDataSuccess, this.getMyAccountDataFail);

    getMyBankAccountData(
      (bankAccountData) => {
        this.setState({ bankAccountData: bankAccountData });
      },
      () => {},
    );

    getMyMooringTypes(
      (mooring_types) => {
        this.setState({ mooring_types: mooring_types });
      },
      (error) => {
        console.log('Error', error);
      },
    );

    getMyMooringZones(
      (mooring_zones) => {
        this.setState({ mooring_zones: mooring_zones });
      },
      (error) => {
        console.log('Error', error);
      },
    );

    getMyContactTypes(
      (contact_types) => {
        this.setState({ contact_types: contact_types });
      },
      (error) => {
        console.log('Error', error);
      },
    );

    this.syncPaymentMethodRouteState();
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.handleWindowFocus);
  }

  getMyAccountDataSuccess = (accountData) => {
    console.log(accountData);
    accountData.password = '';
    this.setState((prevState) => ({
      ...accountData,
      new_payment_method_currency:
        prevState.new_payment_method_currency ||
        accountData.default_currency ||
        'CHF',
    }));
  };

  getMyAccountDataFail = (error) => {};

  handleWindowFocus = () => {
    if (
      this.state.should_refresh_payment_methods_on_focus &&
      this.state.active_tab === 'payment'
    ) {
      this.loadPaymentMethods();
    }
  };

  loadPaymentMethods = () => {
    this.setState({ payment_methods_loading: true }, () => {
      getMyPaymentMethods(
        (payment_methods) => {
          this.setState({
            payment_methods: Array.isArray(payment_methods)
              ? payment_methods
              : [],
            payment_methods_loading: false,
            should_refresh_payment_methods_on_focus: false,
          });
        },
        () => {
          this.setState({
            payment_methods: [],
            payment_methods_loading: false,
            should_refresh_payment_methods_on_focus: false,
          });
        },
      );
    });
  };

  handleTabSelect = (active_tab) => {
    this.setState({ active_tab }, () => {
      if (active_tab === 'payment') {
        this.loadPaymentMethods();
      }
    });
  };

  handleAddPaymentMethod = () => {
    const currency =
      this.state.new_payment_method_currency ||
      this.state.default_currency ||
      'CHF';
    const payment_methods_url = `${window.location.origin}/FindMoorings/account/payment_methods`;
    const redirect_urls = {
      success_url: `${payment_methods_url}?ps=s`,
      failed_url: `${payment_methods_url}?ps=f`,
      cancel_url: `${payment_methods_url}?ps=c`,
    };

    getPayrexxTokenizationLink(
      currency,
      redirect_urls,
      (link) => {
        if (!link) return;
        this.setState({ should_refresh_payment_methods_on_focus: true });
        const payment_window = window.open(link, '_blank');
        if (payment_window) {
          payment_window.opener = null;
        } else {
          window.location.assign(link);
        }
      },
      () => {},
    );
  };

  handleDeletePaymentMethod = (payment_method_id) => {
    const confirmed = window.confirm(
      this.props.t(
        'Account.confirmDeletePaymentMethod',
        'Delete this payment method?',
      ),
    );
    if (!confirmed) return;

    this.setState({ payment_methods_loading: true }, () => {
      deletePaymentMethod(
        payment_method_id,
        () => {
          this.loadPaymentMethods();
        },
        () => {
          this.setState({ payment_methods_loading: false });
        },
      );
    });
  };

  formatPaymentMethodLabel = (payment_method) => {
    const payment_type = payment_method?.type || this.props.t('Account.card', 'Card');
    const card_suffix = payment_method?.card_number
      ? String(payment_method.card_number).slice(-4)
      : '';

    return card_suffix
      ? `${payment_type} •••• ${card_suffix}`
      : payment_type;
  };

  handleUpdateClick() {
    if (
      !Object.values(validateAccountForm(this.state)).every((error) => !error)
    ) {
      // There are some validation errors, do not proceed with updating the account data
      this.setState({
        error: true,
        errorMessage: this.props.t('errors.someValuesAreNotCorrect'),
      });
      return;
    }

    const accountData = this.state;
    this.setState({ loading: true, success: false, error: false }, () => {
      updateAccountData(
        accountData,
        this.updateAccountDataSuccess,
        this.updateAccountDataFail,
      );
      updateMooringTypes(
        this.state.mooring_types,
        () => {},
        () => {},
      );
      updateMooringZones(
        this.state.mooring_zones,
        () => {},
        () => {},
      );
      updateContactTypes(
        this.state.contact_types,
        () => {},
        () => {},
      );
      updateBankAccountData(
        this.state.bankAccountData,
        () => {},
        () => {},
      );
    });
  }

  updateAccountDataSuccess = (response) => {
    this.setState({ loading: false, success: true, error: false });
  };

  updateAccountDataFail = (error) => {
    this.setState({ loading: false, success: false, error: true });
  };

  getPaymentMethodStatusMessage = (status) => {
    if (status === 's') {
      return {
        variant: 'success',
        text: this.props.t(
          'Account.payment_method_add_success',
          'Payment method added successfully.',
        ),
      };
    }

    if (status === 'f') {
      return {
        variant: 'danger',
        text: this.props.t(
          'Account.payment_method_add_failed',
          'Adding the payment method failed.',
        ),
      };
    }

    if (status === 'c') {
      return {
        variant: 'warning',
        text: this.props.t(
          'Account.payment_method_add_cancelled',
          'Adding the payment method was cancelled.',
        ),
      };
    }

    return null;
  };

  syncPaymentMethodRouteState = () => {
    const next_state = {};
    const initial_active_tab = this.props.initialActiveTab || '';
    const payment_method_status = (this.props.paymentMethodStatus || '')
      .trim()
      .toLowerCase();

    if (
      initial_active_tab &&
      initial_active_tab !== this.state.active_tab
    ) {
      next_state.active_tab = initial_active_tab;
    }

    if (
      payment_method_status &&
      ['s', 'f', 'c'].includes(payment_method_status) &&
      payment_method_status !== this.state.payment_method_status
    ) {
      next_state.payment_method_status = payment_method_status;
      next_state.active_tab = 'payment';
    } else if (!payment_method_status && this.state.payment_method_status) {
      next_state.payment_method_status = '';
    }

    if (!Object.keys(next_state).length) {
      return;
    }

    this.setState(next_state, () => {
      if (this.state.active_tab === 'payment') {
        this.loadPaymentMethods();
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.initialActiveTab !== this.props.initialActiveTab ||
      prevProps.paymentMethodStatus !== this.props.paymentMethodStatus
    ) {
      this.syncPaymentMethodRouteState();
      return;
    }

    if (
      this.state.role === 'private' &&
      this.state.active_tab !== 'account' &&
      this.state.active_tab !== 'payment' &&
      this.state.active_tab !== 'bank-account' &&
      this.state.active_tab !== 'password'
    ) {
      this.setState({ active_tab: 'account' });
    }
  }

  render() {
    const { t } = this.props;
    const { headerPaddings = {} } = this.props;
    const {
      showLogoutButton = true,
      saveButtonVariant = 'default',
      showHeaderSaveButton = true,
      showBottomSaveButton = false,
    } = this.props;
    const NoOrYes = t('global.NoOrYes');
    const { role } = this.state;
    const headerPaddingStyle = {
      paddingTop: headerPaddings.top || 0,
      paddingRight: headerPaddings.right || 0,
      paddingBottom: headerPaddings.bottom || 0,
      paddingLeft: headerPaddings.left || 0,
    };

    const dropDownArrowStyle = {
      transition: 'transform 250ms ease', // smooth transition
      float: 'right',
      height: 15,
      marginTop: 8,
      marginRight: 10,
    };

    const formErrors = validateAccountForm(this.state);
    const payment_method_status_message = this.getPaymentMethodStatusMessage(
      this.state.payment_method_status,
    );

    return (
      <div className='account'>
        <Container sm={12}>
          <div className='account__header' style={headerPaddingStyle}>
            <h4 className='account__title'>{t('Account.title')}</h4>
            <div className='account__actions'>
              {showHeaderSaveButton && (
                <Button
                  id='button_save'
                  variant={saveButtonVariant === 'primary' ? 'primary' : undefined}
                  size={saveButtonVariant === 'primary' ? 'sm' : undefined}
                  style={
                    saveButtonVariant === 'primary'
                      ? undefined
                      : {
                          ...globalStyles.saveButton,
                          marginLeft: 0,
                        }
                  }
                  disabled={this.state.loading}
                  onClick={() => this.handleUpdateClick()}>
                  {t('global.save')}
                </Button>
              )}
              {showLogoutButton && (
                <Button
                  id='button_logout'
                  style={{ ...globalStyles.deleteButton }}
                  disabled={this.state.loading}
                  onClick={() =>
                    logoutRequest(
                      () => {
                        window.location.replace('/login');
                      },
                      () => {},
                    )
                  }>
                  {t('Navbar.logout')}
                </Button>
              )}
            </div>
          </div>
          <Row>
            <Col md={12}>
              <StatusAlerts
                state={this.state}
                errorMessage={this.state.errorMessage}
              />
            </Col>
          </Row>
          <Tabs
            id='account-tabs'
            activeKey={this.state.active_tab}
            onSelect={(active_tab) => this.handleTabSelect(active_tab || 'account')}
            className='mb-3'>
            <Tab eventKey='account' title={t('Account.title')}>
              <Row>
                <Col md={12} style={{ backgroundColor: 'white' }}>
                  {/* <FormSegmentedControl
                  label={t('Account.role')}
                  segments={ROLES}
                  onChange={(index) => { this.setState({ role: ROLES[index] }); }}
                  value={this.state.role}
                  error={formErrors?.role}
                /> */}

                  <Row>
                    <Col md={6}>
                      <FormInput
                        as='select'
                        id='input_role'
                        label={t('Account.role')}
                        value={this.state.role}
                        error={formErrors?.role}
                        onChange={(event) => {
                          this.setState({ role: event.target.value });
                        }}
                        disabled>
                        <option value='private'>Private</option>
                        <option value='marina'>Marina</option>
                        <option value='management'>Management</option>
                      </FormInput>
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.salutation')}
                        value={this.state.salutation}
                        error={formErrors?.salutation}
                        onChange={(event) =>
                          this.setState({ salutation: event.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.firstName')}
                        value={this.state.firstname}
                        error={formErrors?.firstname}
                        onChange={(event) =>
                          this.setState({ firstname: event.target.value })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        id={'lastname'}
                        label={t('Account.lastName')}
                        value={this.state.lastname}
                        error={formErrors?.lastname}
                        onChange={(event) =>
                          this.setState({ lastname: event.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormInput
                        as='select'
                        label={t('Account.communicationLanguage')}
                        value={this.state.communication_language}
                        error={formErrors?.communication_language}
                        onChange={(event) =>
                          this.setState(
                            {
                              communication_language: event.target.value,
                            },
                            () => {
                              i18n.changeLanguage(
                                String(event.target.value).toLowerCase(),
                              );
                            },
                          )
                        }>
                        {COMMUNICATION_LANGUAGES.map((language, index) => {
                          return (
                            <option key={index} value={language}>
                              {language}
                            </option>
                          );
                        })}
                      </FormInput>
                    </Col>
                    <Col md={6}>
                      <FormInput
                        disabled
                        type='text'
                        label={t('Account.email')}
                        value={this.state.email}
                        error={formErrors?.email}
                        onChange={(event) =>
                          this.setState({ email: event.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormInput
                        disabled
                        type='tel'
                        label={t('Account.mobile')}
                        value={this.state.mobilenumber}
                        error={formErrors?.mobilenumber}
                        onChange={(event) =>
                          this.setState({ mobilenumber: event.target.value })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.street')}
                        value={this.state.street}
                        error={formErrors?.street}
                        onChange={(event) =>
                          this.setState({ street: event.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.zip')}
                        value={this.state.zip}
                        error={formErrors?.zip}
                        onChange={(event) =>
                          this.setState({ zip: event.target.value })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.city')}
                        value={this.state.city}
                        error={formErrors?.city}
                        onChange={(event) =>
                          this.setState({ city: event.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <CountrySelector
                        label={t('Account.country')}
                        value={this.state.country}
                        error={formErrors?.country}
                        onChange={(value) => this.setState({ country: value })}
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.vat')}
                        value={this.state.vat}
                        error={formErrors?.vat}
                        onChange={(event) =>
                          this.setState({ vat: event.target.value })
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tab>
            {role !== 'private' && (
              <Tab eventKey='booking' title={t('Account.booking_settings')}>
                <Row>
                  <Col md={12} style={{ backgroundColor: 'white' }}>
                    <FormInput
                      type='number'
                      label={t('Account.max_nights_per_year')}
                      value={this.state.max_nights_per_year}
                      error={formErrors?.max_nights_per_year}
                      onChange={(event) =>
                        this.setState({
                          max_nights_per_year: event.target.value,
                        })
                      }
                    />
                    <FormInput
                      type='number'
                      label={t('Account.max_nights_break')}
                      value={this.state.max_nights_break}
                      error={formErrors?.max_nights_break}
                      onChange={(event) =>
                        this.setState({
                          max_nights_break: event.target.value,
                        })
                      }
                    />
                    <FormSegmentedControl
                      label={t('Account.allow_booking_unreleased')}
                      selected={Number(this.state.allow_booking_unreleased)}
                      variant='base'
                      segments={NoOrYes}
                      onChangeSegment={(index) =>
                        this.setState({
                          allow_booking_unreleased: Boolean(index),
                        })
                      }
                    />
                    <FormSegmentedControl
                      label={t('Account.manual_booking_confirmation')}
                      selected={this.state.confirm_bookings}
                      variant='base'
                      segments={NoOrYes}
                      onChangeSegment={(index) =>
                        this.setState({
                          confirm_bookings: index,
                        })
                      }
                    />
                    <FormSegmentedControl
                      label={t('Account.bookingRequestsForLongTermBookings')}
                      selected={this.state.long_stay_on_request}
                      variant='base'
                      segments={NoOrYes}
                      onChangeSegment={(index) =>
                        this.setState({
                          long_stay_on_request: index,
                        })
                      }
                    />
                    {Boolean(this.state.long_stay_on_request) && (
                      <Row>
                        <Col>
                          <FormInput
                            type='number'
                            label={t(
                              'Account.bookingRequestsExceptionPeriodStart',
                            )}
                            value={this.state.exceptions_accept_period_start}
                            error={formErrors?.exceptions_accept_period_start}
                            onChange={(event) =>
                              this.setState({
                                exceptions_accept_period_start:
                                  event.target.value,
                              })
                            }
                          />
                        </Col>
                        <Col>
                          <FormInput
                            type='number'
                            label={t(
                              'Account.bookingRequestsExceptionPeriodEnd',
                            )}
                            value={this.state.exceptions_accept_period_end}
                            error={formErrors?.exceptions_accept_period_end}
                            onChange={(event) =>
                              this.setState({
                                exceptions_accept_period_end:
                                  event.target.value,
                              })
                            }
                          />
                        </Col>
                      </Row>
                    )}

                    {(Boolean(this.state.confirm_bookings) ||
                      Boolean(this.state.long_stay_on_request)) && (
                      <FormSegmentedControl
                        label={t('Account.automatic_response')}
                        selected={this.state.auto_confirm}
                        variant='base'
                        segments={[t('Account.decline'), t('Account.accept')]}
                        onChangeSegment={(index) =>
                          this.setState({
                            auto_confirm: index,
                          })
                        }
                      />
                    )}

                    {(Boolean(this.state.confirm_bookings) ||
                      Boolean(this.state.long_stay_on_request)) && (
                      <FormInput
                        type='number'
                        label={t('Account.automatic_response_after')}
                        unit={'h'}
                        value={this.state.auto_confirm_delay}
                        error={formErrors?.auto_confirm_delay}
                        onChange={(event) =>
                          this.setState({
                            auto_confirm_delay: event.target.value,
                          })
                        }
                      />
                    )}
                  </Col>
                </Row>
              </Tab>
            )}
            <Tab
              eventKey='payment'
              title={t('Account.payment_methods', 'Payment methods')}>
              <Row>
                <Col md={12} style={{ backgroundColor: 'white' }}>
                  {payment_method_status_message && (
                    <Alert
                      variant={payment_method_status_message.variant}
                      className='account__payment-status'>
                      {payment_method_status_message.text}
                    </Alert>
                  )}
                  <div className='account__payment-header'>
                    <div className='account__payment-copy'>
                      {t(
                        'Account.payment_methods_description',
                        'Manage your saved payment methods.',
                      )}
                    </div>
                    <div className='account__payment-actions'>
                      <Form.Group className='account__payment-currency'>
                        <Form.Label className='account__payment-label'>
                          {t('Account.currency', 'Currency')}
                        </Form.Label>
                        <Form.Select
                          size='sm'
                          value={this.state.new_payment_method_currency || 'CHF'}
                          onChange={(event) =>
                            this.setState({
                              new_payment_method_currency: event.target.value,
                            })
                          }>
                          {CURRENCIES.map((currency) => (
                            <option key={currency} value={currency}>
                              {currency}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                      <Button
                        type='button'
                        variant='primary'
                        size='sm'
                        onClick={this.handleAddPaymentMethod}>
                        {t(
                          'Account.add_payment_method',
                          'Add payment method',
                        )}
                      </Button>
                    </div>
                  </div>
                  {this.state.payment_methods_loading ? (
                    <div className='account__payment-empty'>
                      {t('global.loading', 'Loading')}
                    </div>
                  ) : this.state.payment_methods.length === 0 ? (
                    <div className='account__payment-empty'>
                      {t(
                        'Account.no_payment_methods',
                        'No saved payment methods',
                      )}
                    </div>
                  ) : (
                    <div className='account__payment-list'>
                      {this.state.payment_methods.map((payment_method) => (
                        <div
                          key={payment_method.id}
                          className='account__payment-item'>
                          <div className='account__payment-summary'>
                            <img
                              src={creditcard_active}
                              alt={t(
                                'Account.payment_method_icon',
                                'Payment method icon',
                              )}
                              className='account__payment-icon'
                            />
                            <div>
                              <div className='account__payment-title'>
                                {this.formatPaymentMethodLabel(payment_method)}
                              </div>
                              <div className='account__payment-meta'>
                                {t('Account.expiry', 'Expiry')}:&nbsp;
                                {payment_method.expiry || '-'}
                              </div>
                              <div className='account__payment-meta'>
                                {t(
                                  'Account.default_currency',
                                  'Default currency',
                                )}
                                :&nbsp;
                                {payment_method.default_currency || '-'}
                              </div>
                            </div>
                          </div>
                          <Button
                            type='button'
                            variant='outline-danger'
                            size='sm'
                            onClick={() =>
                              this.handleDeletePaymentMethod(payment_method.id)
                            }>
                            {t('global.delete', 'Delete')}
                          </Button>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey='bank-account' title='Bank account for credit notes'>
              <Row>
                <Col md={12} style={{ backgroundColor: 'white' }}>
                  <FormSegmentedControl
                    label={t('Account.currency')}
                    segments={CURRENCIES}
                    onChange={(index) =>
                      this.setState({
                        bankAccountData: {
                          ...this.state.bankAccountData,
                          currency: CURRENCIES[index],
                        },
                      })
                    }
                    selected={CURRENCIES.indexOf(
                      this.state.bankAccountData.currency,
                    )}
                  />
                  <Row>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.iban')}
                        value={this.state.bankAccountData.iban}
                        error={formErrors?.iban}
                        onChange={(event) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              iban: event.target.value,
                            },
                          })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.owner_name')}
                        value={this.state.bankAccountData.owner_name}
                        error={formErrors?.owner_name}
                        onChange={(event) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              owner_name: event.target.value,
                            },
                          })
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.street')}
                        value={this.state.bankAccountData.street}
                        error={formErrors?.street}
                        onChange={(event) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              street: event.target.value,
                            },
                          })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.zip')}
                        value={this.state.bankAccountData.zip}
                        error={formErrors?.zip}
                        onChange={(event) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              zip: event.target.value,
                            },
                          })
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormInput
                        type='text'
                        label={t('Account.city')}
                        value={this.state.bankAccountData.city}
                        error={formErrors?.city}
                        onChange={(event) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              city: event.target.value,
                            },
                          })
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <CountrySelector
                        label={t('Account.country')}
                        value={this.state.bankAccountData.country}
                        error={formErrors?.country}
                        onChange={(value) =>
                          this.setState({
                            bankAccountData: {
                              ...this.state.bankAccountData,
                              country: value,
                            },
                          })
                        }
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Tab>
            {role !== 'private' && (
              <Tab eventKey='email' title={t('Account.email_settings')}>
                <Row>
                  <Col md={12} style={{ backgroundColor: 'white' }}>
                    <FormSegmentedControl
                      label={t('Account.confirmation_emails')}
                      selected={this.state.confirmation_emails}
                      variant='base'
                      segments={NoOrYes}
                      onChangeSegment={(index) =>
                        this.setState({
                          confirmation_emails: index,
                        })
                      }
                    />
                    {Boolean(this.state.confirmation_emails) && (
                      <FormSegmentedControl
                        label={t('Account.confirmation_emails_own')}
                        selected={this.state.confirmation_emails_own}
                        segments={NoOrYes}
                        onChangeSegment={(index) =>
                          this.setState({
                            confirmation_emails_own: index,
                          })
                        }
                      />
                    )}
                    <FormInput
                      type='text'
                      label={t('Account.email_cc')}
                      value={this.state.email_cc}
                      error={formErrors?.email_cc}
                      onChange={(event) =>
                        this.setState({ email_cc: event.target.value })
                      }
                    />

                    <FormInput
                      type='text'
                      label={t('Account.email_admin_cc')}
                      value={this.state.email_admin_cc}
                      error={formErrors?.email_admin_cc}
                      onChange={(event) =>
                        this.setState({ email_admin_cc: event.target.value })
                      }
                    />

                    <Row>
                      <Col>
                        <FormInput
                          type='text'
                          label={t('Account.decimal_separator')}
                          value={this.state.decimal_separator}
                          error={formErrors?.decimal_separator}
                          onChange={(event) =>
                            this.setState({
                              decimal_separator: event.target.value,
                            })
                          }
                        />
                      </Col>
                      <Col>
                        <FormInput
                          type='text'
                          label={t('Account.csv_separator')}
                          value={this.state.csv_separator}
                          error={formErrors?.csv_separator}
                          onChange={(event) =>
                            this.setState({
                              csv_separator: event.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    <FormSegmentedControl
                      label={t('Account.detailed_billing_email')}
                      selected={Number(this.state.show_billing_email_details)}
                      variant='base'
                      segments={NoOrYes}
                      onChangeSegment={(index) =>
                        this.setState({
                          show_billing_email_details: index,
                        })
                      }
                    />

                    {role == 'management' && (
                      <div>
                      <h2>{t('Account.types')}</h2>

                      <Row
                        onClick={() =>
                          this.setState({
                            showMooringTypes: !this.state.showMooringTypes,
                          })
                        }>
                        <Col md={10}>
                          <h3>{t('Account.mooringTypes')}</h3>
                        </Col>
                        <Col>
                          <img
                            style={{
                              ...dropDownArrowStyle,
                              transform: this.state.showMooringTypes
                                ? 'rotate(180deg)'
                                : '',
                            }}
                            src={DropDownIcon}
                            alt='DropDownIcon'
                            className='spin'
                          />
                        </Col>
                      </Row>

                      <Collapse in={this.state.showMooringTypes}>
                        <div id='showMooringTypes'>
                          {this.state.mooring_types.map(
                            (mooring_type, index) => (
                              <div key={index}>
                                <Row md={12}>
                                  <Col md={10}>
                                    <Form.Control
                                      type='text'
                                      label={'platztyp'}
                                      value={
                                        this.state.mooring_types[index]
                                          .mooring_type
                                      }
                                      // error={formErrors?.mooring_types[index]?.mooring_type}
                                      onChange={(event) => {
                                        const new_type = event.target.value;
                                        const mooring_types = [
                                          ...this.state.mooring_types,
                                        ];
                                        const mooring_type =
                                          mooring_types[index];
                                        mooring_type.mooring_type = new_type;
                                        mooring_types[index] = mooring_type;
                                        this.setState({
                                          mooring_types: mooring_types,
                                        });
                                      }}
                                    />
                                  </Col>

                                  <Col md={2}>
                                    <Button
                                      style={globalStyles.deleteButton}
                                      onClick={() => {
                                        const mooring_types = [
                                          ...this.state.mooring_types,
                                        ];
                                        mooring_types.splice(index, 1);
                                        this.setState({
                                          mooring_types,
                                        });
                                      }}>
                                      {t('global.delete')}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ),
                          )}

                          <AddNewButton
                            center
                            label={t('Account.addMooringType')}
                            onClick={() => {
                              const mooring_type = {
                                mooring_type: '',
                              };
                              this.setState({
                                mooring_types: [
                                  ...this.state.mooring_types,
                                  mooring_type,
                                ],
                              });
                            }}
                          />
                        </div>
                      </Collapse>
                      <div
                        style={{
                          width: '100%',
                          height: 1,
                          backgroundColor: COLORS.GRAY_OUTLINE,
                        }}></div>

                      <Row
                        onClick={() =>
                          this.setState({
                            showMooringZones: !this.state.showMooringZones,
                          })
                        }>
                        <Col md={10}>
                          <h3>{t('Account.mooringZones')}</h3>
                        </Col>
                        <Col>
                          <img
                            style={{
                              ...dropDownArrowStyle,
                              transform: this.state.showMooringZones
                                ? 'rotate(180deg)'
                                : '',
                            }}
                            src={DropDownIcon}
                            alt='DropDownIcon'
                            className='spin'
                          />
                        </Col>
                      </Row>
                      <Collapse in={this.state.showMooringZones}>
                        <div id={'showMooringZones'}>
                          {this.state.mooring_zones.map(
                            (mooring_zone, index) => (
                              <div key={index}>
                                <Row md={12}>
                                  <Col md={10}>
                                    <Form.Control
                                      type='text'
                                      label={'platztyp'}
                                      value={mooring_zone.zone}
                                      onChange={(event) => {
                                        const new_zone = event.target.value;
                                        const mooring_zones = [
                                          ...this.state.mooring_zones,
                                        ];
                                        const mooring_zone =
                                          mooring_zones[index];
                                        mooring_zone.zone = new_zone;
                                        mooring_zones[index] = mooring_zone;
                                        this.setState({
                                          mooring_zones: mooring_zones,
                                        });
                                      }}
                                    />
                                  </Col>

                                  <Col md={2}>
                                    <Button
                                      style={globalStyles.deleteButton}
                                      onClick={() => {
                                        const mooring_zones = [
                                          ...this.state.mooring_zones,
                                        ];
                                        mooring_zones.splice(index, 1);
                                        this.setState({
                                          mooring_zones,
                                        });
                                      }}>
                                      {t('global.delete')}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ),
                          )}

                          <AddNewButton
                            center
                            label={t('Account.addMooringZone')}
                            onClick={() => {
                              const mooring_zone = { type: '' };
                              this.setState({
                                mooring_zones: [
                                  ...this.state.mooring_zones,
                                  mooring_zone,
                                ],
                              });
                            }}
                          />
                        </div>
                      </Collapse>
                      <div
                        style={{
                          width: '100%',
                          height: 1,
                          backgroundColor: COLORS.GRAY_OUTLINE,
                        }}></div>

                      <Row
                        onClick={() =>
                          this.setState({
                            showContactTypes: !this.state.showContactTypes,
                          })
                        }>
                        <Col md={10}>
                          <h3>{t('Account.contactTypes')}</h3>
                        </Col>
                        <Col>
                          <img
                            style={{
                              ...dropDownArrowStyle,
                              transform: this.state.showContactTypes
                                ? 'rotate(180deg)'
                                : '',
                            }}
                            src={DropDownIcon}
                            alt='DropDownIcon'
                            className='spin'
                          />
                        </Col>
                      </Row>
                      <Collapse in={this.state.showContactTypes}>
                        <div id={'showContactTypes'}>
                          {this.state.contact_types.map(
                            (contact_type, index) => (
                              <div key={index}>
                                <Row md={12}>
                                  <Col md={10}>
                                    <Form.Control
                                      type='text'
                                      label={'platztyp'}
                                      value={
                                        this.state.contact_types[index].type
                                      }
                                      // error={formErrors?.contact_types[index]?.type}
                                      onChange={(event) => {
                                        const new_type = event.target.value;
                                        const contact_types = [
                                          ...this.state.contact_types,
                                        ];
                                        const contact_type =
                                          contact_types[index];
                                        contact_type.type = new_type;
                                        contact_types[index] = contact_type;
                                        this.setState({
                                          contact_types: contact_types,
                                        });
                                      }}
                                    />
                                  </Col>

                                  <Col md={2}>
                                    <Button
                                      style={globalStyles.deleteButton}
                                      onClick={() => {
                                        const contact_types = [
                                          ...this.state.contact_types,
                                        ];
                                        contact_types.splice(index, 1);
                                        this.setState({
                                          contact_types,
                                        });
                                      }}>
                                      {t('global.delete')}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            ),
                          )}

                          <AddNewButton
                            center
                            label={t('Account.addContactType')}
                            onClick={() => {
                              const contact_type = { type: '' };
                              this.setState({
                                contact_types: [
                                  ...this.state.contact_types,
                                  contact_type,
                                ],
                              });
                            }}
                          />
                        </div>
                      </Collapse>
                      <div
                        style={{
                          width: '100%',
                          height: 1,
                          backgroundColor: COLORS.GRAY_OUTLINE,
                        }}></div>

                      <FormInput
                        as='select'
                        label={t('Account.default_currency')}
                        value={this.state.default_currency}
                        error={formErrors?.default_currency}
                        onChange={(event) =>
                          this.setState({
                            default_currency: event.target.value,
                          })
                        }>
                        {CURRENCIES.map((currency, index) => {
                          return (
                            <option key={index} value={currency}>
                              {currency}
                            </option>
                          );
                        })}
                      </FormInput>

                      <FormInput
                        type='number'
                        label={t('Account.default_periodic_fee')}
                        value={this.state.default_periodic_fee}
                        error={formErrors?.default_periodic_fee}
                        onChange={(event) =>
                          this.setState({
                            default_periodic_fee: event.target.value,
                          })
                        }
                      />

                      <FormInput
                        type='number'
                        label={t('Account.default_registration_fee')}
                        value={this.state.default_registration_fee}
                        error={formErrors?.default_registration_fee}
                        onChange={(event) =>
                          this.setState({
                            default_registration_fee: event.target.value,
                          })
                        }
                      />

                      <FormInput
                        type='number'
                        unit={t('global.year')}
                        label={t('Account.default_payment_period')}
                        value={this.state.default_payment_period}
                        error={formErrors?.default_payment_period}
                        onChange={(event) =>
                          this.setState({
                            default_payment_period: event.target.value,
                          })
                        }
                      />
                      </div>
                    )}
                  </Col>
                </Row>
              </Tab>
            )}
            <Tab eventKey='password' title={t('Account.changePassword')}>
              <Row>
                <Col md={12} style={{ backgroundColor: 'white' }}>
                  <FormInput
                    type='password'
                    label={t('Account.password')}
                    value={this.state.password}
                    error={formErrors?.password}
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    autocomplete='new-password'
                  />
                  <FormInput
                    type='password'
                    label={t('Account.passwordRepeat')}
                    value={this.state.passwordRepeat}
                    error={formErrors?.passwordRepeat}
                    onChange={(event) =>
                      this.setState({ passwordRepeat: event.target.value })
                    }
                    autocomplete='new-password'
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
          {showBottomSaveButton && (
            <div className='account__footer'>
              <Button
                id='button_save_bottom'
                variant={saveButtonVariant === 'primary' ? 'primary' : undefined}
                size={saveButtonVariant === 'primary' ? 'sm' : undefined}
                style={saveButtonVariant === 'primary' ? undefined : globalStyles.saveButton}
                disabled={this.state.loading}
                onClick={() => this.handleUpdateClick()}>
                {t('global.save')}
              </Button>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Account);
